import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import PropTypes from 'prop-types';

const AlertDisplay = styled('div', {
  marginBottom: '2%',
});

export const StatusBanner = ({ referenceNumber, status }) => {
  return (
    <AlertDisplay>
      {status ? (
        <Alert variant="success" title="Thank you for your submission.">
          You will receive an email once your registration has been processed.{' '}
          <b> Your reference number is {referenceNumber || ''}.</b>
        </Alert>
      ) : (
        <Alert title="Unable to process your submission">
          We were unable to process your TIN registraion. Please try again. If
          you continue to receive this message please call our provider support
          team at (123) 345-4444.
        </Alert>
      )}
    </AlertDisplay>
  );
};

StatusBanner.propTypes = {
  referenceNumber: PropTypes.string,
  status: PropTypes.bool.isRequired,
};

StatusBanner.defaultProps = {
  referenceNumber: '',
};
